import { create } from '@bufbuild/protobuf';
import { createClient } from '@connectrpc/connect';
import { useQuery } from '@tanstack/react-query';
import { CheckRequestSchema, StatusService } from '../gen/readiness/v1/readiness_pb';
import { createApiTransport } from '../transport';

/**
 * Hook to check the status of the API
 * @returns Query result with status check data
 */
export function useStatusCheck() {
  return useQuery({
    queryKey: ['status', 'check'],
    queryFn: async () => {
      const transport = createApiTransport();
      const client = createClient(StatusService, transport);
      const request = create(CheckRequestSchema, {});
      return await client.check(request);
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
